import { CircularProgress, ThemeProvider } from '@mui/material';
import { useEffect, useState } from 'react';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import './App.css';
import Footer from './components/Footer/Footer';
import LoginDisabled from './components/Login/LoginDisabled';
import LoginPage from './components/Login/LoginPage';
import SwiperHome from './components/PhyElements/HomePage';
import { ADMIN_ROUTES, USER_ROLES } from './Constants';
import { AuthProvider, useAuth } from './context/AuthContext';
import Dashboard from './main';
import { getEmployeeById } from './services/employeeService';
import { getModulePermissionByRoleID ,getModulesByIds} from './services/ModuleServices';
import { getRoleIdByName } from './services/UserRolesServices';
import theme from './theme';
import AllRoutes from './utils/AllRoutes';
import {ProfileImageProvider} from './context/ProfileImageContext';
import { useAxiosInterceptors } from './services/responseInterceptor';
import ContactPage from './components/Contact/ContactPage';
import CareersPage from './components/Careers/CareersPage';
import AnalogLayout from './components/OurServices/AnalogLayout';
import DesignLayout from './components/OurServices/DesignLayout';
import PhysicalDesign from './components/OurServices/PhysicalDesign';
import { Helmet } from 'react-helmet';

  const TITLE_MAP = {
    "/": "Phyelements - VLSI Semiconductor and Software services company",
    "/services/designlayout": "Phyelements Services",
    "/services/physicaldesign": "Phyelements Services",
    "/careers": "Phyelements Careers",
    "/contact": "Phyelements Contact",
  };

  const GlobalTitleHandler = () => {
    const location = useLocation();

    // Matches exact route path or falls back to a default title
    const currentTitle =
      TITLE_MAP[location.pathname] || "Phyelements Internal HRMS";

    return (
      <Helmet>
        <title>{currentTitle}</title>
      </Helmet>
    );
  };

const AppLayout = () => {
  const location = useLocation();
  const showDashboard = location.pathname !== '/' && location.pathname !== '/hrms/login' && location.pathname !== '/login-disabled' 
                        && location.pathname !== '/contact' && location.pathname !== '/careers' &&  location.pathname !== '/services/designlayout' 
                        && location.pathname!=='/services/physicaldesign' && location.pathname!=='/services/analoglayout';
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated} = useAuth();
  const roleId = localStorage.getItem("roleId");
  const employeeId = localStorage.getItem("employeeId");
  const [menu, setMenu] = useState([]);
  
  useAxiosInterceptors();

  useEffect(() => {
    const fetchModulesPermission = async () => {
      setLoading(true);
      try {
        const roleAssignedModuleIds = await getModulePermissionByRoleID(roleId);
        // const moduleIds = (roleAssignedModuleIds || [] ).filter((row) => row.activeStatus)
        //   .map((row) => row.moduleId);
        // const specificModules = moduleIds.length &&  await getModulesByIds(moduleIds);
        // const associatedMenus = (specificModules || []).map(module => module?.menuItem);
        const associatedMenus = roleAssignedModuleIds.filter(item => item !== null).map(item => item.menuItem); 
        const emploeeRoleId = await getRoleIdByName(USER_ROLES.EMPLOYEE);
        let adminRoleId  =  null;
        if(associatedMenus.length == 0){
         adminRoleId = await getRoleIdByName(USER_ROLES.ADMIN);
        }
        if (roleId === adminRoleId) {
          const filteredMenu = AllRoutes.filter(menuItem => ADMIN_ROUTES.includes(menuItem.key));
          setMenu(filteredMenu);
          setUserPermissions(ADMIN_ROUTES);
        } else if(roleId == emploeeRoleId){
          if(employeeId){
            const employeeInfo = await getEmployeeById(employeeId);
            if (
              !employeeInfo || 
              !employeeInfo.aadhaarFile || 
              !employeeInfo.aadhaarNumber ||
              !employeeInfo.address ||
              !employeeInfo.emergencyContactName ||
              !employeeInfo.emergencyContactNumber ||
              !employeeInfo.gender ||
              !employeeInfo.panFile ||
              !employeeInfo.panNumber ||
              !employeeInfo.phone ||
              !employeeInfo.qualification ||
              !employeeInfo.firstName) {
                const filteredMenu = AllRoutes.filter(menuItem => menuItem.title === "My Profile");
                setMenu(filteredMenu);
                setUserPermissions(["myprofile"]);
              }
              else{
                const filteredMenu  =AllRoutes.filter(menuItem => associatedMenus.includes(menuItem.key));
                setMenu(filteredMenu);
                setUserPermissions(associatedMenus);
              }
          }
        }
        else{
          const filteredMenu = AllRoutes.filter(menuItem => associatedMenus.includes(menuItem.key));
          setMenu(filteredMenu);
          setUserPermissions(associatedMenus);

        }
      } catch (error) {
        console.error("Error fetching module permissions: ", error);
      } finally {
        setLoading(false);
      }
    };
    if (roleId) {
      fetchModulesPermission();
    } else {
      setLoading(false);
    }
  }, [roleId]);

  const filteredRoutes = AllRoutes.filter(route => userPermissions.includes(route.key));

  if (loading) {
    return <div className='loading-container'><CircularProgress /></div>; 
  }

  return (
    <>
      {showDashboard && <Dashboard menus={menu} />}
      <Routes>
        <Route path="/" element={<SwiperHome  />} />
        <Route path="/services/designlayout" element={<DesignLayout />} />
        <Route path="/services/physicaldesign" element={<PhysicalDesign />} />
        {/* <Route path="/services/analoglayout" element={<AnalogLayout />} /> */}
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/hrms/login" element={<LoginPage />} />
        <Route path="/login-disabled" element={<LoginDisabled />} />
        { isAuthenticated ? filteredRoutes.map(route => (
          <Route key={route.path} path={route.path}
            element={route.element}
          />
        )) :  <Route path="*" element={<Navigate to="/hrms/login?status=timeout" replace />} />}
      </Routes>
      {showDashboard && <Footer/>}
      
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
    <GlobalTitleHandler />
      <ThemeProvider theme={theme}>
        <NotificationContainer />
        <AuthProvider>
          <ProfileImageProvider>
            <AppLayout />
          </ProfileImageProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
